export { canUseLocalStorage } from './canUseLocalStorage';
export { localizedFormatDate } from './localizedFormatDate';
export { localizedDistanceToNow } from './localizedDistanceToNow';
export { keyExtractor } from './keyExtractor';
export { isUserAgent } from './deviceUserAgent';
export { objectEntries } from './objectEntries';
